import { render, staticRenderFns } from "./IconArrowSoutheast.vue?vue&type=template&id=87c914f0"
import script from "./IconArrowSoutheast.vue?vue&type=script&lang=js"
export * from "./IconArrowSoutheast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports